module.exports = __webpack_public_path__ + "img/selected2-min.24fece42.png";